// extracted by mini-css-extract-plugin
export var chevron = "_24-d";
export var disabled = "_24-b";
export var error = "_24-c";
export var hideBorder = "_24-1";
export var icon = "_24-e";
export var input = "_24-0";
export var large = "_24-f";
export var open = "_24-9";
export var placeholder = "_24-a";
export var regular = "_24-5";
export var singleRowInput = "_24-2";
export var singleSelectInput = "_24-3 _24-0";
export var small = "_24-4";
export var spinnerContainer = "_24-i";
export var tag = "_24-7";
export var tagsContainer = "_24-8";
export var tagsInput = "_24-6 _24-0";
export var xSmall = "_24-g";
export var xxSmall = "_24-h";